import React, { useState } from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    tipoSolicitud: '',
    nombre: '',
    correo: '',
    telefono: '',
    asunto: '',
    mensaje: ''
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('/contacto.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        alert('✅ Solicitud enviada correctamente.');
        setFormData({
          tipoSolicitud: '',
          nombre: '',
          correo: '',
          telefono: '',
          asunto: '',
          mensaje: ''
        });
      } else {
        alert('❌ Error al enviar: ' + result.message);
      }
    } catch (error) {
      console.error(error);
      alert('❌ Error de red o del servidor.');
    }

    setLoading(false);
  };

  return (
    <section className="st-shape-wrap" id="contact">
      <div className="st-shape1"><img src="shape/contact-shape1.svg" alt="shape1" /></div>
      <div className="st-shape2"><img src="shape/contact-shape2.svg" alt="shape2" /></div>
      <div className="st-height-b120 st-height-lg-b80" />
      <SectionHeading title="Contáctanos" subTitle="Por favor completa el siguiente formulario para enviarnos tu solicitud." />

      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <form onSubmit={onSubmit} className="row st-contact-form st-type1" method="post" id="contact-form">
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Tipo de Solicitud</label>
                  <select name="tipoSolicitud" required value={formData.tipoSolicitud} onChange={handleInputChange}>
                    <option value="" disabled>Seleccione el tipo</option>
                    <option value="Petición">Petición</option>
                    <option value="Queja">Queja</option>
                    <option value="Reclamo">Reclamo</option>
                    <option value="Felicitación">Felicitación</option>
                    <option value="Sugerencia">Sugerencia</option>
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Nombre Completo</label>
                  <input type="text" name="nombre" placeholder="Juan Pérez" required onChange={handleInputChange} value={formData.nombre} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Correo Electrónico</label>
                  <input type="email" name="correo" placeholder="ejemplo@correo.com" required onChange={handleInputChange} value={formData.correo} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Teléfono</label>
                  <input type="tel" name="telefono" placeholder="+57 300 123 4567" required onChange={handleInputChange} value={formData.telefono} />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="st-form-field st-style1">
                  <label>Asunto</label>
                  <input type="text" name="asunto" placeholder="Escriba el asunto" required onChange={handleInputChange} value={formData.asunto} />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="st-form-field st-style1">
                  <label>Mensaje</label>
                  <textarea name="mensaje" rows={7} placeholder="Escriba su mensaje aquí..." required onChange={handleInputChange} value={formData.mensaje}></textarea>
                </div>
              </div>

              <div className="col-lg-12 text-center">
                <button type="submit" className="st-btn st-style1 st-color1 st-size-medium" disabled={loading}>
                  {loading ? "Enviando..." : "Enviar Solicitud"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="st-height-b120 st-height-lg-b80" />
    </section>
  );
};

export default Contact;
